import getPerson from '../../data_management/getPerson'

const CoacheeScreenController = function ($routeParams, $scope, $location, eventsService, initialDataInteractor, workspaceInteractor, personInteractor) {
  const $ctrl = this;

  // onInit
  initialDataInteractor.ensureInitializedSession().then(() => {
    $ctrl.person = getPerson(initialDataInteractor, $routeParams[ 'id' ]);
    createQuestionnaireInstancesList();
  });

  $ctrl.initPostLoad = function (instances) {
    $ctrl.questionnaireInstances = instances;
    $scope.$digest();
  };

  $ctrl.createNewWorkspace = function (name) {
    // console.log($ctrl.person);
    workspaceInteractor.createWorkspace({
      'name': name,
      'memberIds': [ $ctrl.person.id ]
    }).then(w => $scope.$evalAsync(() => {
      $location.path('/workspace/' + w.id);
      eventsService.publishSystemMessage('New workspace created containing ' + $ctrl.person.name);
    }));
  };

  $ctrl.dischargeCoachee = function () {
    return personInteractor.dischargeCoachee($ctrl.person.id)
      .then(() => {
        $scope.$evalAsync(() => {
          $location.path('/people/');
          eventsService.publishSystemMessage('You are no longer coaching ' + $ctrl.person.name);
        });
      })
      .catch(() => eventsService.publishSystemError('Failed to discharge coachee'));
  };

  function createQuestionnaireInstancesList() {
    personInteractor.getQuestionnaireInstances($ctrl.person.id)
      .then(instances => $ctrl.initPostLoad(instances))
      .catch(() => {
        eventsService.failWithMessage("Oops! We could not retrieve this person's list of request instances");
        $scope.$digest();
      });
  }

};

export default {
  name: 'CoacheeScreenController',
  fn: CoacheeScreenController
};